import Header from '../__Layout/Header';
import React , {useState} from "react";
import Loader from '../utils/Loader';
import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!
import { useGetAdminDashboardQuery } from "../Services/api";
export default function Home() {
    const [search, setSearch] = useState("");
    const {
        data: getAdminDashboard,
        isLoading: isGetLoading,
      } = useGetAdminDashboardQuery({params:  {search}  });
      if(isGetLoading) return  <Loader></Loader>
    return (
        <div className="Home">
            <Header />
            <main id="main" className="main">
            <div className="pagetitle">
            <h1>Dashboard</h1>
            <nav>
                <ol className="breadcrumb">
                <li className="breadcrumb-item"><a href="index.html">Home</a></li>
                <li className="breadcrumb-item active">Dashboard</li>
                </ol>
            </nav>
            </div>
            <section className="section dashboard">
            <div className="row">
                <div className="col-lg-12">
                    <div className="row">
                        <div className="col-xxl-4 col-md-6">
                        <div className="card info-card sales-card">


                            <div className="card-body">
                            <h5 className="card-title">Total <span>| students</span></h5>

                            <div className="d-flex align-items-center">
                                <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i className="bi bi-person-square"></i>
                                </div>
                                <div className="ps-3">
                                <h6>{getAdminDashboard?.data}</h6>

                                </div>
                            </div>
                            </div>

                        </div>
                        </div>
                        <div className="col-xxl-4 col-md-6">
                        <div className="card info-card sales-card">
                            <div className="card-body">
                            <h5 className="card-title">Sales <span>| Today</span></h5>
                            <div className="d-flex align-items-center">
                                <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i className="bi bi-cart"></i>
                                </div>
                                <div className="ps-3">
                                <h6>coming soon</h6>
                                <span className="text-success small pt-1 fw-bold">12%</span> <span className="text-muted small pt-2 ps-1">increase</span>

                                </div>
                            </div>
                            </div>
                        </div>
                        </div> 
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="row">
                        <div className="col-xxl-12 col-md-12">
                        <div className="card info-card sales-card">
                            <div className="card-body">
                                <FullCalendar
                                    plugins={[ dayGridPlugin]}
                                    initialView="dayGridMonth"
                                /> 
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                {/* <!---end chart--> */}
            </div>
            </section>
           </main>
        </div>
    );
}